import { i18nPrefix } from './performance-i18n'

const performanceWidgetPt = Object.entries({
    'Link to dashboard': 'Link para o dashboard',
    Consistency: 'Consistência',
    RPI: 'IDS',
    'Potential savings': 'Ganhos Potenciais',
    'Operation time': 'Tempo de operação',
    'Goals planned': 'Metas planejadas',
    'KPIs measured': 'KPIs medidos',
    'Total intervention time': 'Tempo total de intervenção',
    'KPI total time': 'Tempo total de KPI',
    Rig: 'Sonda',
    Rigs: 'Sondas',
    'Rigs association': 'Associação de sondas',
    'Main Table': 'Mesa Principal',
    'Auxiliary Table': 'Mesa auxiliar',
    'RCI (Consistency)': 'ICS (Consistência)',
    'RPI (Performance)': 'IDS (Performance)',
    and: 'e',
    'Permission Required': 'Permissão Necessária',
    'To view the chart, you must have one of the following permissions: Admin or Manage Pipe Widgets.':
        'Para ver este gráfico, você precisa ter uma das seguintes permissões: Admin ou Gerenciar Widgets Pipes'
}).reduce(
    (acc, [key, value]) => ({
        ...acc,
        [`${i18nPrefix}${key}`]: value
    }),
    {}
)

export const ptBr = {
    values: {
        'Loading...': 'Carregando...',
        'No data': 'Sem dados',
        'No data found': 'Nenhum dado encontrado',
        'No data in this range': 'Nenhum dado neste intervalo',
        'KPI Configuration': 'Configuração de KPI',
        drilling: 'perfuração',
        tripping: 'manobra Descida/Subida',
        casing: 'revestimento',
        'Shifts Configuration': 'Configuração de Turno',
        Color: 'Cor',
        'Start.': 'Início',
        End: 'Fim',
        'Are you sure you want to discard all changes': 'Tem certeza que quer descartar todas as alterações',
        'Are you sure you want to save all changes': 'Tem certeza que quer salvar todas as alterações',
        SAVE: 'SALVAR',
        DISCARD: 'DESCARTAR',
        NAME: 'NOME',
        UNIT: 'UNIDADE',
        VALUE: 'VALOR',
        Author: 'Autor',
        'MIN VALUE': 'VALOR MIN',
        TARGET: 'OBJETIVO',
        'MAX VALUE': 'VALOR MAX',
        'CASED HOLE': 'POÇO REVESTIDO',
        'OPEN HOLE': 'POÇO ABERTO',
        'discard changes': 'descartar mudanças',
        'No changes to discard': 'Não há mudanças a serem descartadas',
        'No changes to save': 'Não há mudanças a serem salvas',
        'Save changes': 'Salvar Alterações',
        'GLOBAL CONFIG': 'CONFIGURAÇÕES GLOBAIS',
        'ADD NEW SHIFT': 'ADICIONAR TURNO',
        'Last Saved': 'Última Alteração',
        'Expand Table': 'Expandir Tabela',
        'Default Shifts': 'Turnos Padrão',
        'Please check': 'Por favor corrija',
        'Shift with the same color': 'Turnos com a mesma cor',
        'Overlaping time': 'Conflito entre turnos',
        'minutes unaccounted for': 'minutos não designados',
        'Fields with empty values': 'Campos com valores vazios',
        'Something went wrong': 'Algo deu errado',
        Shift: 'Turno',
        SHIFTS: 'TURNOS',
        'KPI PARAMETERS': 'PARÂMETROS DOS INDICADORES',
        'GENERAL SETTINGS': 'CONFIGURAÇÕES GERAIS',
        'DRILLING KPIs': 'INDICADORES DE PERFURAÇÃO',
        'CASING KPIs': 'INDICADORES DE REVESTIMENTO',
        'TRIPPING KPIs': 'INDICADORES DE MANOBRA',
        'Block Weight': 'Peso do Bloco',

        // Novo
        'Multi KPIs Chart': 'Gráficos Multi KPIs',
        'Apply Filters': 'Aplicar Filtros',
        Apply: 'Aplicar',
        Cancel: 'Cancelar',
        Close: 'Fechar',
        Histogram: 'Histograma',
        Reset: 'Limpar',
        'User favorites': 'FAVORITOS',
        'A curve that represents the cumulative frequency distribution of grouped data on a graph.':
            'Um curva cumulativa representa a frequência de distribuição de um grupo de dados no gráfico.',
        'Cumulative Distribution Curve': 'Curva de Distribuição Cumulativa',
        'VISUALIZATION OPTIONS': 'OPÇÕES DE VISUALIZAÇÃO',
        'Number of Bins': 'Número de Bins',
        'Max Value': 'Valor Máximo',
        'Min Value': 'Valor Mínimo',
        'Max value cannot be less than Min value.': 'O valor mmáximo não pode ser menor do que os valores máximos.',
        'Min value cannot be greater than Max value.': 'O valor mínimo não pode ser maior do que os valores máximos.',
        THRESHOLDS: 'LIMITES',
        'Type to search': 'Digite para pesquisar',
        'items selected': 'itens selecionados',
        'Attention, when clicking on the previous button, all the filling of this Tubular will be erased.':
            'Atenção, ao clicar no botão anterior, todo o preenchimento deste Tubular será apagado.',
        Previous: 'Voltar',
        Finish: 'Finalizar',
        Timespan: 'Intervalo de tempo',
        Intervention: 'Intervenção',
        RUN_KEY: 'corrida',
        ACTIVITY_KEY: 'tipo de tubular / atividades',
        Rigs: 'Sondas',
        Wells: 'Poços',
        'Start with': 'Iniciar com',
        'Add percentile mark': 'Adicionar marca de percentil',
        Period: 'Período',
        'Select a KPI': 'Selecione um KPI',
        'Select KPIs': 'Selecionar KPIs',
        ' Select a rig': 'Selecione uma sonda',
        ' Select a well': 'Selecione um poço',
        'All rigs selected': 'Todas as sondas',
        'All wells selected': 'Todos os poços',
        'The selected Well has been deleted from the Live Wells list. As a result, the RPI per Well stops working, however, this does not affect the RPI per Rig, which continues to work. To solve this problem, simply select another Well in the select options.':
            'O Poço selecionado foi excluído da lista de Poços do Live. Com isso, o IDS por Poço deixa de funcionar, porém, isso não afeta o IDS por Sonda, que continua funcionando. Para resolver este problema, basta selecionar outro Poço nas opções de seleção.',
        Type: 'Tipo',
        'Water Depth': "Profundidade da Lâmina D'água",
        'Geodetic Reference System': 'Sistema de Referência Geodésica',
        'Intervention Tatic': 'Tática de Intervenção',
        Responsible: 'Responsável',
        'Accountable name': 'Nome responsável',
        Riser: 'Riser',
        'No Previous Casing': 'Sem Revestimento Anterior',
        'Prev Casing OD': 'OD do Revestimento Anterior',
        'Prev Casing Final MD': 'MD Final de Revestimento Anterior',
        'RPI Path Status': 'Status de Path RPI',
        'Run Number': 'Número da Corrida',
        'Start Date': 'Data Inicial',
        'End Date': 'Data Final',
        'Start Hour': 'Hora Inicial',
        'End Hour': 'Hora Final',
        'Start MD': 'MD Inicial',
        'Final MD': 'MD Final',
        'Run Final MD': 'MD Final Corrida',
        'Select type': 'Selecione o tipo',
        'Tubulars interval per time': 'Intervalo de tubulares por tempo',
        'Cemented Plug Present': 'Plug Cimentado Presente',
        'Delete this Cement Start MD and Cement Final MD': 'Excluir este MD Inicial e MD Final de Cimento',
        'Add New Cemented Plug': 'Adicionar Novo Plug Cimentado',
        'Run Workstring Current Status': 'Status Atual da Coluna de Trabalho',
        NUMBER: 'NÚMERO',
        INTERVAL: 'INTERVALO',
        PREVIOUS: 'ANTERIOR',
        TIME: 'Tempo',
        DEPTH: 'Profundidade',
        'Increases the length of the last tubular if the final bit depth in the current run is greater than expected.':
            'Aumenta o comprimento do último tubular caso a profundidade final de broca na corrida atual seja maior do que o esperado.',
        'Tubular Type': 'Tipo do Tubular',
        'Tubular Connection Type': 'Tipo de Conexão Tubular',
        'Third Party Responsible': 'Responsável de Terceiros',
        'Permanent Tubular Installation': 'Instalação Tubular Permanente',
        'You must fill this field with a value less than the OD value from the previous section.':
            'Você deve preencher este campo com um valor menor que o valor de OD da seção anterior.',
        'You must fill this field with a value less than the Final MD value from the previous section.':
            'Você deve preencher este campo com um valor menor que o valor de MD Final da seção anterior.',
        'The value of this field is automatically filled in corresponding to the sum of the value of the previous run (Number of the previous run +1) in the same section, obeying the increasing sequence of runs. For example, if the previous run was run 4, the value of this field would be 5, and so on.':
            'O valor deste campo é preenchido automaticamente correspondente à soma do valor da corrida anterior (Número da corrida anterior +1) na mesma seção, obedecendo a sequência crescente de corridas. Por exemplo, se a corrida anterior foi a corrida 4, o valor desse campo deve ser 5 e assim por diante.',
        'You must fill this field with a value greater than the MD Final value from the previous run. Fill this field with a value greater than the MD Final value from the previous run.':
            'Você deve preencher este campo com um valor maior que o valor MD Final da run anterior. Preencha este campo com um valor maior que o valor MD Final da execução anterior.',
        'You must fill this field with a value less than or equal to Section Final MD and greater than Run Start MD.':
            'Você deve preencher este campo com um valor menor ou igual a Section Final MD e maior que Run Start MD.',
        'For insertion of tubulars by time, enable the checkbox. The default behavior is the insertion of tubulars by  Depth (checkbox disabled). Once the Run is started,  the tubulars in the workstring must be configured with the tubular interval type defined here.':
            'Para inserção de tubulares por tempo, habilite a caixa de seleção. O comportamento padrão é a inserção de tubulares por Profundidade (caixa de seleção desabilitada). Uma vez iniciado o Run, os tubulares na coluna de trabalho devem ser configurados com o tipo de intervalo de tubular definido aqui.',
        'When enabled, the KPIs of this Run will be classified as Cemented Plug Present, for Stand Type Inclusion (trip in) only. The Cement Start MD and Cement Final MD fields will be enabled for entering numerical values contained between the Run Start MD and Run Final MD values.':
            'Quando habilitados, os KPIs desta Corrida serão classificados como Plug Cimentado Presente, somente para Stand Type Inclusion (trip in). Os campos MD Inicial e MD final de cimento, serão habilitados para inserir valores numéricos contidos entre os valores MD Inicial e MD Final da Corrida.',
        'This checkbox enabled defines that the last tubular will have its depth extended to the greatest bit depth until run end time, allowing the automatic adjustment of the tubular Final MD. If disabled, there will be no classification of the tubular from the maximum bit depth after tubular and run Final MD.':
            'Esta caixa de seleção habilitada define que o último tubular terá sua profundidade estendida até a maior profundidade de broca até o horário de término da corrida, permitindo o ajuste automático do MD Final do tubular. Se desabilitado, não haverá classificação do tubular a partir da profundidade máxima de bits após o tubular e corrida o MD Final.',
        'Connection types for Screen, Tubing and Casing tubes. The other tubulars will not consider the possibility of connection type and default to the option Not applicable.':
            'Tipos de conexão para Screen, Tubing e Casing tubes. Os demais tubulares não considerarão a possibilidade de tipo de conexão e padrão para a opção Não aplicável.',
        'By checking this box, you are informing that the tubular will be installed in the well permanently and that it will not return to the surface.':
            'Ao marcar esta caixa, você está informando que o tubular será instalado no poço de forma permanente e que não retornará à superfície.',
        'You must fill this field with a value less than the Section OD value when the Tubular Type is Casing.':
            'Você deve preencher este campo com um valor menor que o valor da Seção OD quando o Tipo Tubular for Revestimento.',
        'This field is automatically filled with the Final MD from the previous tubular.':
            'Este campo é preenchido automaticamente com o MD Final do tubular anterior.',
        'You must fill this field with a value less than or equal to the Run Final MD value.':
            'Você deve preencher este campo com um valor menor ou igual ao valor MD Final da Corrida.',
        Rig: 'Sonda',
        Well: 'Poço',
        'All timespan selected': 'Intervalos de tempo selecionados',
        'One or more fields have an error. Please check and try again.':
            'Um ou mais dois campos estão incompletos. Por favor verifique e tente novamente.',
        'Invalid Time Span': 'Time Span inválido',
        'Marks on the graph a target mark that allows visualizing and comparing the proximity of the data distribution with the desired target value.':
            'Marca no gráfico uma alvo que permite visualizar e comparar a proximidade da distribuição dos dados com o valor alvo desejado.',
        'Displays a curve that describes the frequency distribution of a KPI.':
            'Exibe uma curva que descreve a distribuição de frequência de um KPI.',
        items: 'itens',
        'Click to add': 'Clique para adicionar',
        Position: 'Posição',
        Attributes: 'Atributos',
        'All intervention selected': 'Intervenções selecionadas',
        'interventions selected': 'intervenções selecionadas',
        'Data & Filters': 'Dados & Filtros',
        'Chart Settings': 'Configurações',
        Settings: 'Configurações',
        Templates: 'Modelos',
        TEMPLATES: 'MODELOS',
        Template: 'Modelo',
        ' items selected of ': ' itens selecionados de ',
        FREQUENCY: 'FREQUÊNCIA',
        CUMULATIVE: 'CUMULATIVO',
        'Type to search...': 'Digite para pesquisar...',
        Presets: 'Predefinições',
        'Field is missing, please check and try again.': 'Campo faltando, verifique e tente novamente.',
        'The amount of data periods that will be analyzed.': 'Quantidade de períodos de dados que serão analisados.',
        'All time': 'Todo o período',
        'last day': 'Último dia',
        'last week': 'Última semana',
        'last 15 days': 'Últimos 15 dias',
        'last month': 'Último mês',
        'last quarter': 'Último trimestre',
        'last semester': 'Último semestre',
        'last year': 'Último ano',
        'Last day': 'Último dia',
        'Last week': 'Última semana',
        'Last 15 days': 'Ultimos 15 dias',
        'Last month': 'Último mês',
        'Last quarter': 'Último trimestre',
        'Last semester': 'Último semestre',
        'Last year': 'Último ano',
        Advanced: 'Avançado',
        'Standard Deviation': 'Desvio Padrão',
        'Add New Template': 'Adicionar Novo Modelo',
        'Template name...': 'Nome do Modelo...',
        'Save template with current config': 'Salvar modelo com configuração atual',
        'Save Template': 'Salvar Template',
        'Cancel changes': 'Cancelar alterações',
        'Apply Template': 'Aplicar Template',
        'Edit Template': 'Editar Modelo',
        'Delete Template': 'Deletar Modelo',
        Edit: 'Editar',
        'KPI/Channel': 'KPI/Canal',
        'No intervetions selected': 'Sem intervenções selecionadas',
        'All Timespan selected': 'Todo o período',
        'Select a chart type...': 'Selecione o tipo de gráfico...',
        'Save this widget and return to the dashboard.': 'Salvar widget e retornar para o dashboard.',
        'Filters and settings are displayed in visualization mode only.':
            'Filtros e configurações são exibidos apenas no modo de visualização.',
        Cumulative: 'Cumulativo',
        'Select a KPI/Channel': 'Selecione um KPI/Channel',
        EVENTS: 'EVENTOS',
        'Potential Savings': 'Economia de Tempo',
        'since ts 0': 'Todo o período',
        All: 'Todos',
        'TARGET(MEDIAN)': 'TARGET(MEDIANA)',
        'POTENTIAL SAVINGS': 'ECONOMIA DE TEMPO',
        'BELOW TARGET': 'ABAIXO DA META',
        'ABOVE TARGET': 'ACIMA DA META',
        'TOTAL SAVED': 'TOTAL ECONOMIZADO',
        TOTAL: 'TOTAL',
        Median: 'Mediana',
        'Target must be greater than zero': 'Valor objetivo deve ser maior que zero.',
        'Degree of dispersion of a data set. Indicates how uniform a data set is. The closer to zero the standard deviation, the more homogeneous the data are.':
            'Grau de dispersão de um conjunto de dados. Indica o quão uniforme é um conjunto de dados. Quanto mais próximo de 0 o desvio padrão, mais homogêneos são os dados.',
        'Shows the time sums above and below the target (if there is no target, consider the median). The difference between these values is the total time saved, if greater than zero, or wasted, otherwise.':
            'Mostra os somatórios de tempo acima e abaixo do alvo (se não há um alvo, considera a mediana). A diferença entre estes valores é o total de tempo economizado, se maior que zero, ou perdido, caso contrário.',
        HISTOGRAM: 'HISTOGRAMA',
        'Changes applied with success': 'Mudanças salvas com sucesso',
        'Template applied.': 'Template aplicado.',
        'Current config saved on Template.': 'Configuração atual salva no Modelo.',
        'The current configuration does not match the original configuration of this Template. Click the Save Current Config button to update the template or the Add New Template button to create a new template from the current configuration.':
            'A configuração atual não corresponde à configuração original deste modelo. Clique no botão Editar Modelo > Salvar modelo com configuração atual, para atualizar o modelo, ou no botão Adicionar Novo Modelo para criar um novo modelo com a configuração atual.',
        'You must fill the Template name.': 'Você deve preencher o nome do Modelo.',
        'This name has already been defined in another Template. Please, choose another name.':
            'Este nome já foi definido em outro Template. Por favor, escolha outro nome.',
        'Template was applied successfully': 'O Modelo foi aplicado com sucesso',
        The: 'O',
        'config was applied to generate the histogram.': 'foi aplicado para gerar o histograma.',
        'The histogram was successfully generated with the current config':
            'O histograma foi gerado com sucesso com a configuração atual',

        // Novo
        'Annotation Tool': 'Ferramenta de Anotação',
        'Review Options': 'Opções de Revisão',
        'Review Option': 'Opção de Revisão',
        'Select period': 'Selecionar período',
        'Select asset': 'Selecionar ativo',
        'Zoom In': 'Ampliar',
        'Zoom Out': 'Reduzir',
        'Reset Zoom': 'Redefinir',
        Options: 'Opções',
        'View KPIs': 'Ver KPIs',
        'Select method...': 'Selecionar método...',
        'Select method': 'Selecionar método',
        'Sequential Time Review': 'Revisão de Tempo Sequencial',
        'Cutoff Filters (Min, Max, Relative Deviation)': 'Filtros de Atalho (Mín, Max, Desvio Relativo)',
        'Zoom Settings': 'Configurações de zoom',
        'All Time': 'Todo o período',
        'Every 3 minutes': 'A cada 3 minutos',
        'Every 15 minutes': 'A cada 15 minutos',
        'Every 30 minutes': 'A cada 30 minutos',
        'Every 20 minutes': 'A cada 20 minutos',
        'Every hour': 'A cada hora',
        'Every Two Hours': 'A cada Duas Hora',
        'Every KPIs': 'Every KPIs',
        'Every 2 KPIs': 'Every 2 KPIs',
        'Every 3 KPIs': 'Every 3 KPIs',
        'Every 5 KPIs': 'Every 5 KPIs',
        'Below Min': 'Mín Abaixo',
        'Above Max': 'Max Acima',
        Deviation: 'Desvio',
        'TOOLTIP COLOR': 'ESTILO DO TOOLTIP',
        'CHANNEL OPTIONS': 'OPÇÕES DO CANAL',
        'KPIS REVIEW PANE': 'INSPECIONAR KPIS',
        'See kpis': 'Ver kpis',

        'is a system pattern that can be overriden in each rig parameters.':
            'é um padrão do sistema que pode ser sobrescrito na página de parâmetros de cada sonda.',
        'For some reason, no shift information was returned. Check your connection and try again later.':
            'Por algum motivo, não foi encontrado nenhuma configuração de turno. Verifique sua internet e tente novamente mais tarde.',
        "For some reason, your request couldn't be saved": 'Por algum motivo, as informações não puderam ser salvas',
        'It is not possible to add more than 6 shifts.': 'Não é possível adicionar mais de 6 turnos.',
        'At least one shift has to be configured.': 'Pelo menos um turno deve estar configurado.',
        'Algorithm Thresholds': 'Limites do Algoritmo',
        'Target Settings': 'Configurações de Objetivo',
        'Colors Configuration': 'Configuração de Cores',
        'Colors Settings': 'Definição de Cores',
        'Colors saved successfully.': 'Cores salvas com sucesso.',
        Identification: 'Identificação',
        'Value must be bigger than zero': 'O valor deve ser maior que zero',
        'Value smaller than or equal to min value': 'Valor menor ou igual ao valor mínimo',
        'Value smaller than or equal to target value': 'Valor menor ou igual ao valor objetivo',
        'Value larger than or equal to target value': 'Valor maior ou igual ao valor objetivo',
        'Value larger than or equal to max value': 'valor maior ou igual ao valor máximo',
        'Default operation shifts should be applied to all active rigs, unless there is a different profile defined here in this section.':
            'As configurações padrão de turno serão aplicadas a todas as sondas a não ser que seja definido um perfil diferente.',
        'Values set here will affect rig values with overriden parameters which can be accessed on each rig option on the “Operational Targets” tab.':
            'Os valores configurados aqui podem ser sobrescritos na pagina individual de cada sonda na aba "Objetivos Operacionais" ',
        "Use this page to configure how crew's shifts should be assingned. The shifts should each have a diferent color and a different time span. No shift can overlap with another. You can configure between 1 and 6 shifts.":
            'Use essa pagina para configurar como cada turno de uma equipe deve ser designado. Cada turno deve ter uma cor e um período diferente. Não é permitido que haja sobreposição dos horários de cada turno. Você pode configurar entre 1 e 6 turnos.',
        'This time represents the time spent since the operator turns off the pumps until the moment the pump brings the flow again. Actually it is the time without flow rate.':
            'Representa o tempo gasto do momento em que o operador desliga as bombas até o momento em que as bombas retornam o fluxo. É o tempo sem a taxa de vazão.',
        'This is the time spent in slips and making a connection during tripping operations.':
            'É o tempo gasto nas cunhas e fazendo as conexões durante as manobras de descida/subida.',
        'The Pipe Moving Time represents the time needed for running one stand of drill pipe in or out of the hole. Actually it is the time between two slip to slip connections.':
            'Representa o tempo necessário para acontecer um estágio de drill pipe dentro ou fora do poço. É o tempo entre duas conexões slip to slip.',
        'This is the average speed the pipe is tripped in or out of the hole as a combination of pipe moving time and in slips time.':
            'É a velocidade média em que ocorre a manobra de descida ou subida do poço, uma combinação de tempo de movimentação do tubo e tempo nas cunhas.',
        'The Gross Time per Stand KPI represents the time needed for the pipe to be tripped in or out of the hole as a combination of pipe moving time and in slips time.':
            'Representa o tempo necessário para que ocorra a manobra de descida ou subida do poço, uma combinação de tempo de movimentação do tubo e tempo nas cunhas.',
        'This is the time spent in slips during running casing and/or liner (excluding the drill pipe!) in the cased hole or open hole.':
            'É o tempo gasto nas cunhas durante a descida de revestimento e/ou  liner (excluindo o drill pipe!) tanto no poço aberto quanto no poço revestido.',
        'This is the average speed the joint is moved during running casing and/or liner (excluding the drill pipe!) in the cased hole or open hole.':
            'É a velocidade média em que a junta é movida durante a descida do revestimento e/ou liner (excluindo o drill pipe!) tanto no poço aberto quanto no poço revestido.',
        'This KPI represents the time needed for running one joint of casing/liner into the cased hole. Actually it is the time between two casing/liner slip to slip connections.':
            'Representa o tempo necessário para descer uma junta de revestimento/liner dentro do poço revestido. É o tempo entre duas conexões casing/liner slip to slip.',
        'The KPI Gross Time per Stand represents the time needed for a joint to be run in the cased hole or open hole as a combination of pipe moving time and in slips time.':
            'Representa o tempo necessário para que uma junta seja manuseada dentro do poço aberto ou revestido como uma combinação de tempo de movimentação do tubo e tempo nas cunhas.',
        'This is the average speed the joint is run in the cased hole or open hole as a combination of pipe moving time and in slips time.':
            'É a velocidade média em que a junta é manuseada dentro do poço aberto ou revestido como uma combinação de tempo de movimentação do tubo e tempo nas cunhas.',
        'This is the rate for a joint to be run in the cased hole or open hole as a combination of pipe moving time and in slips time. Actually it is the Casing – Gross Running Speed divided by an average casing joint length.':
            'É a frequencia em que uma junta  é manuseada dentro do poço aberto ou revestido como uma combinação de tempo de movimentação do tubo e tempo nas cunhas. É a Velocidade Total de Descida dividida por um comprimento médio da junta de revestimento.',
        'Weight to Weight Minimum Flow': 'Fluxo Mínimo de Weight to Weight ',
        'Weight to Weight Minimum Flow Duration': 'Duração de Fluxo Mínima de Weight to Weight',
        'Weight to Weight Off Bottom Threshold': 'Limite Fora do Fundo de Weight to Weight',
        'Weight to Weight On Bottom Threshold': 'Limite no Fundo Weight to Weight',
        'Weight to Weight Minimum BPOS': 'Posição do Bloco Mínima de Weight to Weight ',
        'Slip to Slip Minimum HKLD': 'Carga no Gancho Mínima de Slip to Slip',
        'Slip to Slip Minimum Flow': 'Fluxo Mínimo de Slip to Slip',
        'Slip to Slip Maximum Flow': 'Fluxo Máximo de Slip to Slip',
        'Pump to Pump time': 'Tempo de Pump to Pump',
        'Weight to Weight Time': 'Tempo de Weight to Weight',
        'Weight to Slip Time': 'Tempo de Weight to Slip',
        'Slip to Slip Connection Time': 'Tempo de Conexão Slip to Slip',
        'Slip to Weight Time': 'Tempo de Slip to Weight',
        'Gross Time per Stand': 'Tempo Total por Seção',
        'Gross Drilling ROP per Stand': 'Taxa Total de Perfuração por Seção',
        'Rotating Drilling Time per Stand': 'Tempo de Perfuração Rotativa por Seção',
        'Rotating Drilling Meterage per Stand': 'Metragem de Perfuração Rotativa por Seção',
        'Rotating Drilling ROP per Stand': 'Taxa de Perfuração Rotativa por Seção',
        'Sliding Drilling Time per Stand': 'Tempo de Perfuração Orientada por Seção',
        'Sliding Drilling Meterage per Stand': 'Metragem de Perfuração Orientada por Seção',
        'Sliding Drilling ROP per Stand': ' Taxa de Perfuração Orientada por Seção',
        'Average Pipe Moving Speed': 'Média do Tempo de Movimentação do Tubo',
        'Pipe Moving Time': 'Tempo de Movimentação do Tubo',
        'Gross Running Speed': 'Velocidade Total de Descida',
        'Gross Running Rate': 'Taxa Total de Descida',
        'This is the time spent in slips and making a connection during drilling operations.':
            'É o tempo gasto em cunhas e fazendo as conexões durante as operações de perfuração.',
        'A Weight to Weight Connection represents the time between two drilled stands. This KPI starts when the drill string is lifted off from bottom and lasts until the string is on bottom drilling again.':
            'Representa o tempo entre duas seções perfuradas. É iniciado quando a coluna de perfuração é levantada do fundo e dura até que a coluna de perfuração esteja no fundo perfurando novamente.',
        'The Weight to Slips Time KPI is only calculated during a weight to weight connection. This KPI starts when the bit is lifted off bottom and lasts until the drill string is in slips.':
            'Este kpi somente é calculado durante uma conexão weight to weight. É iniciado quando a broca é levantada do fundo e dura até que a coluna de perfuração esteja nas cunhas.',
        'The Slips to Weight Time KPI is only calculated during a weight to weight connection. This KPI starts when the drill string is released out of the slips and lasts until the bit is on bottom drilling again.':
            'Este kpi somente é calculado durante uma conexão weight to weight. É iniciado quando a coluna de perfuração é solta para fora das cunhas e dura até que a broca esteja no fundo perfurando novamente.',
        'This is the time spent since the pump has been turned off until the pumps come with flow again.':
            'É o tempo gasto desde que a bomba foi desligada até que a bomba tenha fluxo novamente.',
        'This is the total time needed for drilling one stand of pipe including the weight to weight connection. Actually it covers all time from the end of a weight to weight connection until the end of the subsequent one.':
            'É o tempo necessário para perfurar uma seção de tubo, incluindo a conexão weight to weight. É todo o tempo desde o final de uma conexão weight to weight até o fim da subsequente.',
        'This KPI is calculated by dividing the drilled distance for one stand of pipe with the Drilling Gross Time KPI.':
            'Esse KPI é calculado dividindo a distância perfurada pelo valor total do tempo de uma seção',
        'The Rotating Drilling Time for one stand of pipe represents the time drilling in rotary mode. This covers only the on bottom time and excludes any stops during drilling down a stand (e.g. wellbore conditioning, toolface orientation, weight to weight connections, etc.).':
            'Representa o tempo de perfuração em modo rotativo. Somente inclui o tempo no fundo e exclui qualquer parada durante a perfuração de uma seção. (e.g. condicionamento de poço, conexões weight to weight...)',
        'This is the distance per stand that was drilled in rotary mode.':
            'É a distancia por seção que foi perfurada em modo rotativo.',
        'This is the ROP per stand that was drilled in sliding mode. Actually it is calculated by dividing the Sliding Drilling Meterage with the Sliding Drilling Time.':
            'É a taxa de perfuração por seção em modo orientado. É calculado dividindo a metragem de perfuração orientada pelo tempo de perfuração orientada.',
        'The Sliding Drilling Time for one stand of pipe represents the time drilling in sliding mode. This covers only the on bottom time and excludes any stops during drilling down a stand (e.g. wellbore conditioning, toolface orientation, weight to weight connections, etc.).':
            'O tempo de perfuração orientada para uma seção de tubo representa o tempo em modo de perfuração orientada. Somente inclui o tempo no fundo e exclui qualquer parada durante a perfuração de uma seção. (e.g. condicionamento de poço, conexões weight to weight...)',
        'This is the distance per stand that was drilled in sliding mode.':
            'É a distância por seção que foi perfurada em modo orientado.',
        'This is the minimum time with pump off without weight on bit.':
            'Tempo mínimo com a bomba desligada sem peso sobre broca.',
        'This is the minimum distance from the bit to the bottom, to consider that drilling has started or resumed.':
            'Distância mínima da broca em relação ao fundo, indica que que iniciou-se ou foi retomada a perfuração.',
        'This is the maximum distance from the bit to the bottom to consider that it is not drilling.':
            'Distância máxima da broca em relação ao fundo, indica que que não está havendo perfuração.',
        'This is the minimum height of the block in relation to the rotary table, to consider that it is not drilling.':
            'Altura mínima do bloco em relação a mesa rotativa, indica que que está havendo perfuração.',
        'This is the maximum residual value during connection.': 'Valor máximo residual durante conexão.',
        'KPI Options': 'Opções de KPI',
        'Stand created successfully': 'Stand criado com sucesso.',
        'Stand splitted successfully': 'Stand dividido com sucesso.',
        'Stand edit has been done successfully.': 'Edição do stand feita com sucesso.',
        'KPI delete has been done successfully.': 'KPI removido com sucesso.',
        'Failure on delete KPI. Please try again.': 'Falha ao remover KPI. Por favor, tente novamente.',
        'Failure on KPI edition.': 'Falha na edição do KPI',
        'KPI edit has been done successfully.': 'KPI editado com sucesso.',
        'Failure on stand edit. This change is not allowed.': 'Falha na edição do stand. Esta mudança não é permitida.',
        'Failure on stand delete.': 'Falha ao deletar o stand.',
        'Are you sure you want to delete the stand ': 'Tem certeza que deseja deletar o stand ',
        Reprocess: 'Reprocessar',
        'Input event type': 'Tipo do evento de entrada',
        'Output event type': 'Tipo do evento de saida',
        'Choose reprocessing span': 'Escolha o período do reprocessamento',
        'If no span is entered, "from ts 0" will be used as default':
            'Se nenhum período for selecionado, será utilizado como padrão o período: "from ts 0"',
        'Reprocessing...': 'Reprocessando...',
        Expand: 'Expandir',
        Minimize: 'Minimizar',
        'Channel Reader': 'Leitor de Canais',
        'KPI Reader': 'Leitor de KPIs',
        'Slip To Sequential Time Review': 'Revisão de Tempo Sequencial',
        Filters: 'Filtros',
        'Anchor to Left': 'Fixar zoom à Esquerda',
        'Anchor to Right': 'Fixar zoom à Direita',
        'Anchor to Center': 'Fixar zoom no Centro',
        'Zoom Mode': 'Modo de Zoom',
        'Filter Channels': 'Filtrar Canais',
        'KPI Channels': 'Canais de KPI',
        'Filter Qualifier Channels': 'Filtrar Canais Qualificadores',
        'Filter visualization of qualifier channels': 'Filtrar visualização de canais qualificadores no gráfico',
        TRACK: 'TRILHA',
        'QUALIFIER CHANNELS': 'CANAIS QUALIFICADORES',
        Clear: 'Limpar',
        'Edit S2S annotations': 'Editar anotações de S2S',
        'Edit W2W annotations': 'Editar anotações de W2W',
        'Edit P2P annotations': 'Editar anotações de P2P',
        'Edit ROP annotations': 'Editar anotações de ROP',
        'Edit TRIPPING_IN annotations': 'Editar anotações de TRIPPING IN',
        'Edit TRIPPING_OUT annotations': 'Editar anotações de TRIPPING OUT',
        'Edit STAND annotations': 'Editar anotações de STAND',
        'Zoom amount': 'Quantidade de zoom',
        'Zoom in': 'Ampliar',
        'Zoom out': 'Reduzir',
        'Undo time span': 'Voltar ao período de tempo anterior',
        'Reset time span': 'Voltar ao período de tempo inicial',
        'Return initial time span': 'Retomar período de tempo anterior',
        'Return to previous time span': 'Retomar período de tempo inicial',
        'Display channels values in the chart tooltip while reading data':
            'Exibir valores de canais no leitor do gráfico',
        'Display KPIs information in the chart tooltip while reading data':
            'Exibir informações de KPIs no leitor do gráfico',
        'Backward time window': 'Janela de tempo anterior',
        'Forward time window': 'Janela de tempo seguinte',
        '3 minutes ago': 'Voltar 3 minutos',
        '3 minutes ahead': 'Avançar 3 minutos',
        'KPI NAME': 'NOME',
        'START TIME': 'INÍCIO',
        'END TIME': 'FIM',
        DURATION: 'DURAÇÃO',
        'Backward partial time window': 'Janela de tempo anterior parcial',
        'Forward partial time window': 'Janela de tempo seguinte parcial',
        'KPI SPEED': 'VELOCIDADE',
        channel: 'canal',
        channels: 'canais',
        'Are you sure you want to delete the KPI': 'Tem certeza que deseja deletar o KPI',
        'Failure creating KPI.': 'Ocorreu um erro ao criar o KPI.',
        'KPI creation has been done successfully.': 'O KPI foi criado com sucesso',
        'Failure editing KPI.': 'Ocorreu um erro ao editar o KPI',
        'KPI update has been done successfully.': 'O KPI foi atualizado com sucesso',
        "Create a Live Lookup Table with Pipes' time span values to setup your own time span presets, then set the table's macro as":
            'Crie uma Lookup Table do Live com valores de intervalos de tempo em Pipes para configurar suas próprias predefinições de tempo, em seguida defina o macro da tabela como',
        "Create a Live Lookup Table with review time values in minutes to setup your own review options, then set the table's macro as":
            'Crie uma Lookup Table do Live com valores de revisão de tempo em minutos para configurar suas próprias opções de revisão, em seguida defina o macro da tabela como',
        BROKEN_RULE_1:
            'S2S, W2W, P2P e ROP não são KPIs de Tripping! Não é possível criar um KPI de Drilling nesse stand de Tripping!',
        BROKEN_RULE_2:
            'Tripping IN/OUT não são KPIs de Drilling! Não é possível criar um KPI de Tripping nesse stand de Drilling!',
        BROKEN_RULE_3: 'S2S, ROP e Tripping IN/OUT não podem ocorrer em múltiplos Stands!',
        BROKEN_RULE_4: 'W2W e P2P sempre ocorrem entre exatamente dois Stands consecutivos!',
        BROKEN_RULE_5: 'Não podem haver múltiplas anotações do mesmo KPI em um único Stand!',
        BROKEN_RULE_6: 'Anotações de S2S, ROP e Tripping IN/OUT não podem se sobrepor!',
        BROKEN_RULE_7: 'Todas as anotações de KPI precisam de um Stand ID!',
        BROKEN_RULE_8: 'Tripping IN KPI não pode ser criado em um stand de tripping out (removal)!',
        BROKEN_RULE_9: 'Tripping OUT KPI não pode ser criado em um stand de tripping in (inclusion)!',
        INVALID_TRIPPING_DISQUALIFIED: 'KPI de tripping inválido, evento disqualified',
        ROP_KPI_MUST_BE_INSIDE_DRILLING_STAND: 'KPIs de ROP devem estar dentro de um stand de drilling',
        STAND_TYPE_EMPTY: 'Tipo de stand vazio',
        'KPI Goals saved successfully.': 'Metas de KPI gravadas com sucesso',
        'Macro Operations': 'Operações Macro',
        'Tubular run applicable goals': 'Metas aplicáveis de passagem tubular',
        'Macro Operation': 'Operação Macro',
        'Tubular-Activities': 'Tubular-Atividades',
        'Stand Size': 'Tamanho da Stand',
        'Tubular OD': 'OD Tubular',
        'Movement Direction': 'Direção do Movimento',
        'Section Hole Status': 'Status do Poço',
        'Restricted Performance': 'Performance Restrita',
        'No Restricted Performance': 'Sem Restrição de Performance',
        'All Restricted Performance fields need to be filled in to be able to close the modal. Fill in all fields or delete the Restricted Performance being filled.':
            'Todos os campos de Performance Restrita precisam ser preenchidos para poder fechar o modal. Preencha os campos ou exclua a Performance Restrita que está sendo preenchida.',
        'Material Type': 'Tipo de Material',
        goals: 'metas',
        maxCutOff: 'corte máximo',
        minCutOff: 'corte mínimo',
        rigReferenceValue: 'valor de referência da sonda',
        Unrestricted: 'Irrestrito',
        Unities: 'Unidades',
        'KPI Goals': 'Metas de KPI',
        'KPI GOALS': 'METAS DE KPI',
        'Rig Reference Value': 'Valor de referência da sonda',
        'Min Cut Off': 'Corte mínimo',
        'Max Cut Off': 'Corte máximo',
        'Stand Size': 'Tamanho do Stand',
        'Stand Type': 'Tipo do Stand',
        'Do you confirm these KPI Goals?': 'Você confirma essas metas de KPI?',
        'KPI Goals Settings': 'Configuração de Metas de KPI',
        Drilling: 'Perfuração',
        Tripping: 'Manobra',
        'If you turn this feature on, you will be able to create a Total Stand Time goal and it will be applied as a performance indicator in the Rigs where it is assigned.':
            'Ao ativar este recurso, você poderá criar uma meta de Tempo Total de Stand e ela será aplicada como um indicador de desempenho nas Sondas onde for atribuída.',
        'Total Stand Time KPI': 'Tempo total do Stand KPI',
        'tst-off': 'desligado',
        'tst-on': 'ligado',
        'This feature allows you to create a Total Stand Time goal. To turn this feature on or off, go to KPI Configuration, choose KPI Goals Settings and the Tripping operation macro.':
            'Este recurso permite que você crie uma meta de tempo total de Stand. Para ativar ou desativar esse recurso, vá para Configurações de KPI, escolha Configuração de Metas de KPI e a macro operação Manobra.',
        'Total Stand Time is now an indicator': 'O Tempo Total de Stand agora é um indicador',
        'When turn on this feature, the Total Stand Time goal will be applied as an indicator in the rigs. This action can be reversed.':
            'Ao ativar este recurso, a meta de tempo total de Stand será aplicada como um indicador nas sondas. Esta ação pode ser revertida.',
        'Are you sure you want to discard all changes? By changing the tab all your goal values will be lost':
            'Tem certeza de que deseja descartar todas as alterações? Ao alterar a guia, todos os seus valores de meta serão perdidos',
        'Search KPI Goal': 'Pesquisar Metas de KPI',
        'ADD KPI GOAL': 'ADICIONAR META DE KPI',
        'Goals saved successfully.': 'Metas salvas com sucesso.',
        'Goals updated successfully.': 'Metas atualizadas com sucesso.',
        'Goals deleted successfully.': 'Metas excluídas com sucesso.',
        'Are you sure you want delete this goal?': 'Tem certeza de que deseja excluir esta meta?',
        'Showing all': 'Exibindo tudo',
        'Invalid timespan. Resetting to default configuration.':
            'Período de tempo inválido. Redefinindo para a configuração padrão.',
        'The first timespan cannot be bigger than current date/hour. Resetting to default configuration.':
            'O primeiro intervalo de tempo não pode ser maior que a data / hora atual. Redefinindo para a configuração padrão.',
        'The start timespan cannot be bigger than end timespan.':
            'O tempo de início não pode ser maior que o tempo final.',
        "Can't fetch Standard Channels from Live.": 'Não foi possível carregar os Canais Padrão do Live.',
        'Are you sure you want to dismiss this event? The alert will be permanently deleted.':
            'Tem certeza de que deseja descartar este evento? O alerta será excluído permanentemente.',
        DISMISS: 'DESCARTAR',
        'KPI’s start edge.': 'Borda inicial do KPI',
        ' alerts without review': ' alertas sem revisão',
        ' alert without review': ' alerta sem revisão',
        'No alerts for review': 'Não existem alertas para revisão',
        'Take me there': 'Leve-me lá',
        Dismiss: 'Descartar',
        'Review panel': 'Painel de revisão',
        'There is a pending review of reprocessed event at': 'Há uma revisão pendente do evento reprocessado em',
        at: 'às',
        intervention: 'intervenção',
        'section / phase': 'seção / fase',
        'rig table status': 'status da mesa rotativa',
        'tubular type': 'tipo tubular',
        'create event': 'criar evento',
        'start new section / phase': 'iniciar nova seção / fase',
        'Select an option': 'Selecione uma opção',
        inches: 'polegadas',
        in: 'pol',
        Confirm: 'Confirmar',
        'Outside Diameter (OD)': 'Diâmetro Externo (OD)',
        'Beginning Measured Depth (MD)': 'Profundidade Inicial (MD inicial)',
        'Final Measured Depth (MD)': 'Profundidade Final (MD final)',
        'Begin Date': 'Data Inicial',
        'End Date': 'Data Final',
        Time: 'Horário',
        Reason: 'Motivo',
        Critical: 'Crítico',
        'Select a status': 'Selecione o status',
        'Select a type': 'Selecione o tipo',
        RpiRelevantPath: 'Trajeto Relevante RPI',
        RPINonRelevantPath: 'Trajeto Não Relevante RPI',
        Main: 'Principal',
        Auxiliary: 'Auxiliar',
        Day: 'Diurno',
        Night: 'Noturno',
        Schedule: 'Cronograma',
        'required field': 'campo obrigatório',
        'Previous Casing Final OD': 'OD Final Anterior',
        'Previous Casing Final MD': 'MD Final Anterior',
        Crew: 'Equipe',
        'Select a shift': 'Selecione o turno',
        REAL_TIME_AGGREGATION_WARNING:
            'A compressão de dados em tempo real está desligada. Nenhum novo dado comprimido está sendo gerado.',
        'Select the KPIs of interest.': 'Selecione os KPIs de interesse.',
        'No KPI selected': 'Nenhum KPI selecionado',
        'KPI(s) selected': 'KPI(s) selecionado(s)',
        "Can't fetch KPI indicators parameters.": 'Não foi possível carregar parâmetros de indicadores KPI.',
        "Can't fetch user's selected KPI parameters.":
            'Não foi possível carregar os parâmetros de indicadores KPI selecionados do usuário.',
        "Can't save KPI parameters.": 'Não foi possível salvar os parâmetros de indicadores KPI.',
        'Default KPI parameters was applied.': 'Parâmetros de indicatores KPI padrão foi aplicado.',
        "Can't apply KPI parameters.": 'Não foi possível aplicar os parâmetros de indicatores KPI.',
        'Select the KPIs of interest by stand type.': 'Selecione os KPIs de interesse pelo tipo de Stand.',
        'Are you sure you want delete this KPI goal?': 'Tem certeza que deseja remover essa meta de KPI?',
        Goal: 'Meta',
        'Delete only the last tubular.': 'Apagar apenas o último tubular.',
        'Delete the tubular set (Run Workstring).': 'Apagar o conjunto tubular (Coluna de Trabalho).',
        'Are you sure you want to delete?': 'Tem certeza de que deseja excluir?',
        'All child events will be deleted along with this one.':
            'Todos os eventos filho serão excluídos junto com este.',
        'This action cannot be undone.': 'Essa ação não poderá ser desfeita.',
        'Confirm deletion': 'Confirmar exclusão',
        'You can swap just a goal for time.': 'Você só pode trocar uma meta por vez.',
        'Tubular Activies': 'Atividades Tubulares',
        'Swap Goals': 'Alterar Metas',
        'Save KPI Goal': 'Salvar metas de KPI',
        'Import Global KPI Goal': 'Importar meta de KPI global',
        'Customize Imported Goals': 'Customizar metas importadas',
        'Add KPI Goal': 'Adicionar metas de KPI',
        'Download Static Data': 'Baixar Static Data',
        'Delete goal to this rig': 'Deletar meta para esta sonda',
        'Edit goal to this rig': 'Editar meta para esta sonda',
        'Swap to the selected goal': 'Trocar para a meta selecionada',
        'Add selected KPI goals on the rig': 'Adicionar metas de KPI selecionadas na sonda',
        'Select a goal from global goals list to use on this rig':
            'Selecione uma meta da lista de metas globais para usar nesta sonda',
        'Swap current goal to another on KPI goal global list':
            'Alterar a meta atual para outra da lista de metas globais',
        'Goals swapped successfully.': 'Metas alteradas com sucesso.',
        'Bit Depth values are automatically loaded. If they are empty, you must fill them.':
            'Os valores de Bit Depth são automaticamente carregados. Se estiverem vazios, você deve preenche-los',
        'Hole Depth values are automatically loaded. If they are empty, you must fill them.':
            'Os valores de Hole Depth são automaticamente carregados. Se estiverem vazios, você deve preenche-los',
        'No Goals saved for this Tubular Type...': 'Não há metas salvas para esse tipo de tubular.',
        'Please fill all fields': 'Por favor, preencha todos os campos',
        'Delay Automatic Detection of KPIs': 'Atrasar a Detecção Automática de KPIs',
        'Time delay': 'Tempo de atraso',
        'The value filled in this field corresponds to the delay time (in minutes) that will be applied on the Automatic Detection of KPIs, to correct the KPI classification. This value will apply to all Rigs as global setting.':
            'O valor preenchido neste campo corresponde ao tempo de atraso (em minutos) que será aplicado na Detecção Automática de KPIs, para corrigir a classificação dos KPIs. Este valor será aplicado a todas as sondas como configuração global.',
        'KPI delay saved successfully.': 'Atraso de KPI salvo com sucesso.',
        'Applies a delay in the automatic detection of KPIs in minutes, for all assets where it is possible to generate KPIs waiting for a buffer time, avoiding losing events that are eventually received out of order.':
            'Aplica um atraso na detecção automática de KPIs em minutos, para todos os ativos em que seja possível gerar KPIs esperando um tempo de buffer, evitando perder eventos eventualmente recebidos fora de ordem.',
        'A value of 0 minute makes real-time automatic detection of runtime/receipt KPIs. Although it is possible, it is not recommended, as data from channels that generate KPIs received out of order at runtime can result in the generation of KPIS with low quality/assertivity and high oscillation of rig state.':
            'Um valor de 0 minuto, torna em tempo real a detecção automática de KPIs em tempo de execução/recebimento de dados. Embora seja possível, não é recomendável, já que dados de canais que geram KPIs recebidos fora de ordem em tempo de execução, podem resultar na geração de KPIS com baixa qualidade/assertividade e alta oscilação de estados de sonda (rig state).',
        'NOTE: The delay will be counted in each operation cycle, all rigstates, stands and KPIs contained in a *closed* stand (KPIs have a detection delay of at least 1 stand); therefore, in long constant operations, such as drilling, which can take hours to complete without changing the rigstate, there may be a delay of hours from the completion of the current operation, added to the delay time for the detection to be completed.':
            'OBS: O atraso será contabilizado a cada ciclo de operação, todos os rigstates, stands e KPIs contidos em um stand *fechado* (KPIs possuem atraso de deteção de ao menos 1 stand); sendo assim, em operações constantes longas, como por exemplo, drilling, que pode levar horas para finalizar sem mudança de rigstate, poderá haver atraso de horas da finalização da operação vigente, adicionado ao tempo de atraso para que a detecção seja finalizada.',
        'Realtime Rig State Channels Configuration': 'Configuração de Canais em Tempo Real dos Estados da Sonda',
        'Rig State Channels Realtime Configuration': 'Configuração de Canais em Tempo Real dos Estados da Sonda',
        'Customize for Reprocessing': 'Customizar para Reprocessamento',
        'Rate of Penetration': 'Taxa de Penetração',
        'Block Position': 'Posição do Bloco',
        'Weight on Bit': 'Peso sobre a broca',
        'SPP Pressure': 'Pressão SPP',
        'Surface Torque': 'Torque de Superfície',
        'Mud Flow In': 'Fluxo de Entrada de Lama',
        Hookload: 'Carga de Gancho',
        'Surface RPM': 'RPM da Superfície',
        'Rig State Channels for Reprocessing': 'Canais de Estado da Sonda para Reprocessamento',
        'New KPI Goal': 'Nova Meta de KPI',
        'Swap KPI Goals': 'Trocar Metas de KPI',
        'Customize Rig State Channels for Reprocessing': 'Customizar Canais do Estado da Sonda para Reprocessamento',
        'Real time': 'Tempo Real',
        'KPI SERVICE': 'SERVIÇO DE KPI',
        'Macro Operation': 'Operação Macro',
        History: 'Histórico',
        'SELECTED CHANNELS': 'CANAIS SELECIONADOS',
        'Select KPI channel': 'Selecionar canal de KPI',
        'Add channel': 'Adicionar canal',
        'Restore Chart Defaults': 'Restaurar padrão',
        'Custom color': 'Escolher cor',
        'Attention!': 'Atenção!',
        'When you select a new asset as a data source, realtime service is automatically turned off, and it can be turned back on right after choosing the new asset.':
            'Quando você selecionar um novo ativo como fonte de dados, o serviço em tempo real é automaticamente desativado e pode ser reativado logo após a escolha do novo ativo.',
        'Do you want to select a new asset as a data source source?':
            'Você deseja selecionar um novo ativo como fonte de dados?',
        'RigState Channels Configuration': 'Configuração dos Canais de RigState',
        'RigState Channels Settings': 'Configuração dos Canais de RigState',
        'Channels and Parameters saved successfully. Kpi realtime generation will be reloaded...':
            'Canais e parâmetros salvos com sucesso. Geração de KPI em tempo real vai ser recarregada...',
        'Channels saved successfully. Kpi realtime generation will be reloaded...':
            'Canais salvos com sucesso. Geração de KPI em tempo real vai ser recarregada...',
        'Are you sure you want to change configs? This will reload the kpi service and restart all realtime kpi generations.':
            'Você tem certeza que deseja mudar as configurações? Isso vai recarregar o serviçõ de KPI e reiniciar todas as gerações de KPI em tempo real.',
        CHANNEL: 'CANAL',
        INTERPOLATION: 'INTERPOLAÇÃO',
        'FREQUENCY OF INTERPOLATION': 'FREQUÊNCIA DE INTERPOLAÇÃO',
        'MAXIMUM DELTA TIME TO NOT INTERPOLATE': 'TEMPO MÁXIMO DE DELTA PARA NÃO INTERPOLAR',
        sec: 'seg',
        'Mandatory completion': 'Preenchimento obrigatório',
        'Required field': 'Campo obrigatório',
        'Would you like to start realtime service from last valid span':
            'Gostaria de reiniciar o serviço de tempo real do último período de tempo válido?',
        YES: 'Sim',
        'KPI Compressed Settings': 'Configurações de KPI Compactado',
        'Compressed Time Settings': 'Configuração do Tempo Compactado',
        'Uncompressed Time': 'Tempo descompactado',
        'Are you sure you want to change the settings? This will reset the period to be visualized with uncompressed channel data in the Annotation Tool and Temporal Chart in 24h dashboard Widgets.':
            'Tem certeza de que deseja alterar as configurações? Isso redefinirá o período a ser visualizado com dados de canal não compactados no widget Ferramenta de Anotação e no Dashboard 24h.',
        now: 'agora',
        'Restore Default': 'Restaurar padrão',
        'The value filled in this field corresponds to the time (in hours) that will be applied to channels selected in the Annotation Tool and Temporal Chart in 24h dashboard Widgets, to toggle uncompressed to compressed channel base.':
            'O valor preenchido neste campo corresponde ao tempo (em horas) que será aplicado aos canais selecionados na Ferramenta de Anotação e no Gráfico Temporal nos widgets do Dashboard 24h, para alternar de base de canais descompactada para compactada.',
        'Since the Annotation Tool and Temporal Chart in 24h dashboard Widgets expects real time compressed channel data, if span is larger than 6 hours, the selection of any alternative channel that is not in the real time KPIs list will result in a blank channel.':
            'Como o widget Ferramenta de Anotações e o Gráfico Temporal no Dashboard 24h esperam dados de canal compactados em tempo real, se o intervalo for maior que 6 horas, a seleção de qualquer canal alternativo que não esteja na lista de KPIs em tempo real, resultará em um canal em branco.',
        'To overcome this issue, this option will able to configure how many hours the user wants to switch from compressed to uncompressed base on Annotation Tool Widget or 24h Dashboard.':
            'Para contornar esse problema, esta opção poderá configurar quantas horas o usuário deseja alternar de base compactada para descompactada no widget Ferramenta de Anotação ou no Dashboard 24h.',
        'Attention!': 'Atenção!',
        'Uncompressed Time was created successfully.': 'O tempo descompactado foi criado com sucesso.',
        'Are you sure you want to save configuration? This will change the saved channels when creating or editing next kpis':
            'Tem certeza que deseja salvar as configurações? Isso irá alterar os canais salvos quando criar ou editar os próximos kpis.',
        'ATW KPI Channels': 'Canais de KPI no ATW',
        CONFIRM: 'CONFIRMAR',
        NO: 'NÃO',
        'There is a different rig in the reprocess period you selected. If you reprocess this period using the present rig, it will overwrite the information as if it were done with the present rig.':
            'Existe uma sonda diferente no período de reprocessamento selecionado. Se você reprocessar este período usando a sonda atual, ele sobrescreverá as informações como se tivesse sido feita com a sonda atual.',
        'There are events generated for: ': 'Existem eventos gerados para: ',
        'Do you want to select this period anyway?': 'Deseja selecionar esse período mesmo assim?',
        'in the period from': 'no periodo de',
        to: 'até',
        'Select a well to active real time.': 'Selecione um well para ativar o tempo real.',
        'Apply reprocess': 'Aplicar reprocessamento',
        ' already has a rig associated with it. It is not possible to generate KPI in real time with a well assigned to more than one rig.':
            ' já possui uma sonda associada. Não é possível gerar KPI em tempo real com um poço associado a mais de uma sonda.',
        'Rig associated with Well: ': 'Sonda associada ao poço: ',
        'To enable realtime processing in the present configuration, you must turn off real time in the ':
            'Para habilitar o processamento em tempo real na presente configuração, você deve desligar o tempo real no ',
        'the following channels were utilized to generate KPIs': 'os seguintes canais foram utilizados para gerar KPIs',
        'KPI Channel': 'Canal KPI',
        'KPI channels on period.': 'Canais no período.',
        'Error when start reprocessing.': 'Erro ao iniciar o reprocessamento.',
        'Please, fill a period to reprocess!': 'Por favor, preencha um período para reprocessar!',
        "Couldn't get data on period": 'Não existem dados no período.',
        'Max delay value is 1440 minutes (1 day).': 'O valor máximo de atraso é de 1440 minutos (1 dia).',
        'Max compressed time value is 240 hours (10 days).': 'O valor máximo de atraso é de 240 horas (10 dia).',
        'Datasource origin': 'Origem da fonte de dados',
        'You need permission to edit the fields bellow. Contact the administrator.':
            'Você precisa de permissão para editar os campos abaixo. Entre em contato com o administrador.',
        'You need permission to edit the field bellow. Contact the administrator.':
            'Você precisa de permissão para editar o campo abaixo. Entre em contato com o administrador.',
        Stick: 'Aderir',
        'When enabling this toggle, the manually moved KPI will automatically stick the Stand (except KPIs between Stands and overlapping KPIs) or nearest KPI visible on the screen.':
            'Ao habilitar este toggle, o KPI movimentado manualmente irá aderir-se automaticamente ao Stand (exceto KPIs entre Stands e sobrepostos) ou KPI mais próximo visível na tela.',
        'You need permission to edit the toggle on the side. Contact your administrator.':
            'Você precisa de permissão para editar o toggle ao lado. Entre em contato com o administrador.',
        "You don't have permission to create an event. Please contact your system administrator.":
            'Você não tem permissão para criar um evento. Entre em contato com o administrador do sistema.',
        "You don't have permission to view this dashboard. Please contact your system administrator.":
            'Você não tem permissão para visualizar este painel. Entre em contato com o administrador do sistema.',
        'If you select well as data source, it will cause KPIs to be generated from the collection of normalized channels of selected well.':
            'Se você selecionar o poço como fonte de dados, isso fará com que os KPIs sejam gerados a partir da coleção de canais normalizados do poço selecionado.',
        'All Wells': 'Todos os poços',
        'Wells with active interventions': 'Poços com intervenção ativa',
        'Select a well to active real time': 'Selecione um poço para ativar o tempo real',
        'The span must be less than 60 days.': 'O período deve ser menor que 60 dias.',
        'The expanded span must be less than 90 days.': 'O período estendido deve ser menor que 90 dias.',
        'Please wait to change the asset, we are pre-loading some data from ':
            'Por favor aguarde para alterar o ativo, estamos pré carregando alguns dado de ',
        Unrestricted: 'Sem restrições',
        Restricted: 'Restrito',
        'This value is greater than to the Run Final MD': 'Este valor é maior que o MD Final da Corrida',
        'Tubular type option is required for goals to appear':
            'A opção de tipo tubular é necessária para que as metas apareçam',
        'Editing or creating KPI goals will modify the performance calculation in Platform Performance Index dashboards.':
            'Editar ou criar metas de KPI modificará o cálculo de performance nos painéis do Índice de Performace da Plataforma.',
        'Are you sure you want to complete this action?': 'Tem certeza de que deseja concluir esta ação?',
        // Well Operations Navigation
        INTERVENTION: 'INTERVENÇÃO',
        'SECTION/PHASE': 'SEÇÃO/FASE',
        RUN: 'CORRIDA',
        'Intervention name': 'Nome da Intervenção',
        'Section OD': 'OD da Seção',
        'Run Number': 'Número da Corrida',
        'Run Type': 'Tipo da Corrida',
        'Section not started': 'Seção não iniciada',
        'Run not started': 'Corrida não iniciada',
        'No Static Data found in the selected period': 'Nenhum dado estático encontrado no período selecionado',
        // Pipe
        'Pipe Movement': 'Movimento do Tubo',
        'Restricted Pipe Movement: ': 'Movimento Restrito de Tubulação: ',
        'Restricted Pipe Movement Type': 'Tipo de Movimento Restrito de Tubulação',
        'Restricted Movement Goal': 'Meta do Movimento Restrito',
        'Add Restricted Pipe Movement': 'Adicionar Movimento Restrito de Tubulação',
        'You must fill this field with a value greater than or equal to the Tubular Start MD value and greater than the previous Restricted Pipe Movement Type Final MD.':
            'Você deve preencher este campo com um valor maior ou igual ao valor do MD Inicial do Tubular e maior que o MD Final do Tipo de Movimento de Tubulação Restrito anterior.',
        'This field is automatically filled with values defined in KPI Goals of the Rig.':
            'Este campo é preenchido automaticamente com os valores definidos nas Metas de KPI da Plataforma.',
        'Pipe MovementKey': 'de Movimento do Tubo',
        'KPI Pipe Moving': 'KPI de Movimento do Tubo',
        or: 'ou',
        'Restricted Movement Speed': 'Velocidade do Movimento Restrito.',
        Refresh: 'Atualizar',
        // Connection Type
        'Connection Type': 'Tipo de Conexão',
        'Restricted Connection: ': 'Conexão Restrita: ',
        'Restriction Type': 'Tipo de Restrição',
        'Restricted Connection Goal': 'Meta de Conexão Restrita',
        'Add Restricted Connection': 'Adicionar Conexão Restrita',
        'Click to more information': 'Clique para mais informações',
        'Missing information': 'Faltando informações',
        'You must fill this field with a value greater than or equal to the Tubular Start MD value and greater than the previous Restriction Type Final MD.':
            'Você deve preencher este campo com um valor maior ou igual ao valor de MD Inicial Tubular e maior que o MD Final do Tipo de Restrição anterior.',
        'You must fill this field with a value less than or equal to the Run Final MD value and greater than the Start MD.':
            'Você deve preencher este campo com um valor menor ou igual ao valor Run Final MD e maior que o MD Inicial.',
        "You must fill this field with a value greater than or equal to the tubular's Start Date/Hour value (when it is the first Restricted Performance) or greater than the End Date/Hour of the previous Restricted Performance.This checkbox enabled defines that the first tubular will have its depth extended to the greatest bit depth, allowing the automatic adjustment of the Final MD to the same value of Run Final MD. If disabled, there will be no classification of the tubular from the maximum bit depth.":
            'Você deve preencher este campo com um valor maior ou igual ao valor da Data/Hora de Início do tubular (quando for o primeiro Restrição de Performance) ou maior que a Data/Hora Final do Restrição de Performance anterior. Esta caixa de seleção habilitada define que o primeiro tubular terá sua profundidade estendida até a maior profundidade de bit, permitindo o ajuste automático do Final MD para o mesmo valor de Run Final MD. Se desabilitado, não haverá classificação do tubular a partir da profundidade máxima de bits.',
        'This field is automatically filled with the End Date/Hour from the previous tubular':
            'Este campo é preenchido automaticamente com a Data/Hora Final do tubular anterior',
        ConnectionKey: 'de Conexão',
        'Restricted Time Connection': 'Tempo de Conexão Restrita.',
        // RESTRICTED RATE OF PENETRATION
        'Restricted Rate of Penetration: ': 'Taxa de Penetração Restrita: ',
        'Restricted ROP': 'ROP Restrito',
        'Restricted ROP Goal': 'Meta de ROP Restrita',
        'Add Restricted Rate of Penetration': 'Adicionar Taxa de Penetração Restrita',
        'You must fill this field with a value greater than or equal to the Tubular Start MD value and greater than the previous Restricted ROP Final MD.':
            'Você deve preencher este campo com um valor maior ou igual ao valor do MD Inicial Tubular e maior que o MD Final ROP Restrito anterior.',
        'You must fill this field with a value less than or equal to the Run Final MD value and greater than the Start MD.':
            'Você deve preencher este campo com um valor menor ou igual ao valor Run Final MD e maior que o MD Inicial.',
        'There is no KPI Goal applied for this Restricted Performance':
            'Não há meta de KPI aplicada à este Desempenho Restrito',
        'You must set a value by going to': 'Você deve definir um valor acessando',
        'Rig KPI Goals': 'Rig KPI Goals',
        'In the KPI Goals list, define as many Restricted Performance goals as you need for the':
            'Na lista de metas KPI, defina quantas metas de Desempenho Restrito forem necessários para o',
        'KPI ROP per Stand': 'KPI ROP per Stand',
        'for tubular': 'para o tubular',
        'After saving, return to this modal. The values will be loaded into the':
            'Após salvar, volte para este modal. Os valores serão carregados no campo',
        'Restricted ROP Speed': 'Velocidade ROP Restrita.',
        'field.': ' ',
        'Please Select a Rig on Asset Filter': 'Por favor selecione uma sonda no filtro de asset',
        'An asset selected on filter is necessary': 'É necessário selecionar um asset de filtro',
        'This field is automatically filled with the KPI Goal value of the KPI ROP per Stand in KPI Goals of the Rig.':
            'Este campo é preenchido automaticamente com o valor da Meta de KPI do KPI ROP por Stand nas Metas de KPI da Plataforma.',
        'This field is filled with values defined in KPI Goals of the Rig. Only values referring to the selected unit are given as options. For values in another unit, select the corresponding unit.':
            'Este campo é preenchido com valores definidos em Metas de KPI da Rig. Apenas os valores referentes à unidade selecionada são fornecidos como opções. Para valores em outra unidade, selecione a unidade correspondente.',
        // API MESSAGES
        'Entity created successfully.': 'Entidade criada com sucesso',
        'Entity tubulartype by depth created successfully.': 'Entidade de tubular por profundidade criado com sucesso.',
        unablecreatetubbydepth: 'Não foi possível criar a entidade de tubular por profundidade:',
        'Error getting entity options.': 'Erro ao obter opções de entidade',
        'Unable to fetch unities for type.': 'Não foi possível buscar unidades para o tipo.',
        'Unable to fetch entities for Rig ID': 'Não foi possível buscar entidades por Rig ID',
        'Unable to fetch entities for type.': 'Nao foi possível buscar entidades por tipo.',
        'Error getting start timestamp for entity.': 'Erro ao obter o carimbo de data/hora de início da entidade.',
        'Error getting end timestamp for entity.': 'Erro ao obter o carimbo de data/hora de fim da entidade.',
        'Unable to fetch entity.': 'Não foi possível buscar a entidade.',
        'Entity deleted successfully.': 'Entidade apagada com sucesso.',
        'Unable to delete entity.': 'Não foi possível excluir a entidade.',
        'Invalid entity creation.': 'Entidade inválida para criação.',
        'Entity updated successfully.': 'Entidade atualizada com sucesso',
        'Unable to fetch assets for rig.': 'Não foi possível buscar ativos por rig.',
        'Unable to fetch live wells.': 'Não foi possível buscar poços do live',
        'Unable to get rig id from name': 'Não foi possível obter o id do rig do nome',
        'Unable to fetch kpi goals with filter.': 'Não foi possível buscar metas de kpi com filtro.',
        'Could not create': 'Não foi possível criar',
        'Unable to create entity': 'Não foi possível criar a entidade',
        // API MESSAGES phaseAPI
        'Error getting previous casing from Tubular Type and Run.':
            'Erro ao obter o revestimento anterior do Tubular e da Corrida.',
        'Error getting well type of section well.': 'Erro ao obter tipo de poço da seção',
        // API MESSAGES runAPI
        'Error getting Start and Run Number from Run.': 'Erro ao obter Início e número da corrida de Corrida.',
        'Tubulars configuration updated successfully': 'Configuração de tubular atualizada com sucesso',
        'Unable to update tubulars configuration: ': 'Não foi possível atualizar a configuração dos tubulares: ',
        'The run tubulars were successfully deleted': 'Os tubulares de corrida foram excluídos com sucesso',
        'Unable to delete run tubulars': 'Não foi possível excluir os tubulares de corrida',
        // CHART COMPONENT
        'Track disabled': 'Faixa desabilitada',
        'You need to start an event on the tospan layer.': 'Você precisa iniciar um evento na camada acima.',

        /// // Rig Performance Index Table /////
        'Discarded KPIs': 'KPIs descartados',
        'Discarded KPIs Table': 'Tabela de KPIs Descartados',
        Duration: 'Duração',
        'Result Log': 'Registro de Resultado',
        Acronym: 'Acrônimo',
        'Operations and KPIs Indicators': 'Indicadores de Operações e KPIs',
        'Performance Over Time': 'Performance ao longo do tempo',
        RIG: 'SONDA',
        RPI: 'IDS',
        'Rig Responsible': 'Responsável da Sonda',
        'Total Operations Time': 'Tempo Total de Operações',
        'RPI Coverage': 'Cobertura IDS',
        days: 'dias',
        day: 'dia',
        hours: 'horas',
        hour: 'hora',
        Well: 'Poço',
        timespan: 'intervalo de tempo',
        'operation type': 'tipo de operação',
        periods: 'períodos',
        'operation and kpi': 'operação e kpi',
        'Operation and KPI': 'Operação e KPI',
        rpi: 'ids',
        'kpi goal': 'meta kpi',
        'kpi quantity': 'quantidade de kpi',
        planned: 'planejado',
        measured: 'medido',
        'potential savings over goal': 'resultado sobre a meta',
        'ilt over goal': 'tempo perdido oculto',
        'gains over goal': 'ganho sobre a meta',
        'Error getting table.': 'Erro ao obter tabela',
        'Please, select a Rig on Asset Filter and set a timespan':
            'Por favor, selecione uma Sonda no Filtro de Ativos e defina um intervalo de tempo',
        'Delete Restricted Performance': 'Remover Restrição de Performance',
        'No Restriction Applied': 'Sem Restrição Aplicada',
        'There is no Restricted Performance defined for this tubular. Click the Add Restricted button to include.':
            'Não há restrição de performance defenida para este tubular. Clique no botão abaixo para incluir.',
        'Choose date': 'Escolher data',
        'This field is automatically filled with the Prev Casing OD from the previous section.':
            'Este campo é preenchido automaticamente com o OD do Revestimento Anterior da seção anterior.',
        'This field is automatically filled with the Prev Casing Final MD from the previous section.':
            'Este campo é preenchido automaticamente com o MD Final de Revestimento Anterior da seção anterior.',
        'Please correct the highlighted fields': 'Por favor, preencha os campos destacados em vermelho corretamente',
        'Add New Cemented Plug': 'Adicionar Novo Plugue Cimentado',
        'When saved this action cannot be undone.': 'Ao salvar, esta operação não poderar ser desfeita.',
        'Are you sure you want to change this?': 'Tem certeza de que deseja alterar isso?',
        'All restrictions will be deleted.': 'Todas as restrições serão excluídas.',
        'Could not find given Asset': 'Não foi possível encontrar determinado ativo',
        'Could not find any kpi goals for this timespan':
            'Não foi possível encontrar nenhuma meta de KPI para este período',
        'Could not find any static data for this timespan':
            'Não foi possível encontrar dados estáticos para este período',
        'Could not query static data entities for this timespan':
            'Não foi possível consultar entidades de dados estáticos para este período',
        'Could not get static data entities for this timespan':
            'Não foi possível obter entidades de dados estáticos para este período',
        'Could not find any kpi for this timespan': 'Não foi possível encontrar nenhum KPI para este período',
        'Could not find any stand for this timespan': 'Não foi possível encontrar nenhum stand para este período',
        'A problem occurred while searching bit depth event for this timespan':
            'Ocorreu um problema ao pesquisar o evento de profundidade de bit para este período',
        'Could not find any bit depth event for this timespan':
            'Não foi possível encontrar nenhum evento de profundidade de bit para este período',
        "Could not find the deepest bit depth event for run's last tubular extension":
            'Não foi possível encontrar o evento de profundidade de bit mais profundo para a última extensão tubular da corrida',
        'A negative KPI value was found': 'Um valor de KPI negativo foi encontrado',
        'A negative GOAL value was found': 'Um valor de META negativo foi encontrado',
        'IDS denominator is equal to zero': 'O denominador IDS é igual a zero',
        'No KPI was considered in the calculation': 'Nenhum KPI foi considerado no cálculo',
        'An unhandled problem was found while calculating IDS':
            'Um problema não resolvido foi encontrado ao calcular o IDS',
        'Download result log': 'Baixar registro de resultados',
        'It was not possible to do the download.': 'Não foi possível fazer o download.',
        'Static Data Importer': 'Importador de Dados Estáticos',
        'Import Data': 'Importar dados',
        'Select a': 'Selecione um(a)',
        'you want to move this': 'que você quer mover esse(a)',
        'to.': 'para.',
        'Validate Entities': 'Validar entidades',
        'Transfer to Static Data': 'Transferir para Static Data',
        'KPI Goal Versions': 'Versões de Metas de KPI',
        'KPI Goal Versions by Operations': 'Versões de Metas de KPI por Operações',
        'No goal version to display.': 'Nenhuma versão de meta para exibir.',
        Operation: 'Operação',
        'KPI Goal Version': 'Versão da Meta do KPI',
        'No goal version': 'Versão sem meta',
        Move: 'Mover',

        // Static Data Import
        'You can import or create static data entries for a well.':
            'Você pode importar ou criar entradas de dados estáticos para um poço.',
        'Import data': 'Importar dados',
        'Create data': 'Criar dados',
        'Import Configuration': 'Configuração de Importação',
        'Standard Configuration': 'Configuração Padrão',
        'New Configuration': 'Nova Configuração',
        'The values ​​defined in Standard Configuration correspond to the respective column and enum values ​​in the Template CSV. If you want to change these values, select another configuration option.':
            'Os valores definidos na Configuração Padrão correspondem aos respectivos valores de coluna e enum no Modelo de CSV. Se desejar alterar esses valores, selecione outra opção de configuração.',
        'The values ​​defined on the left must not be changed. The values ​​on the right must be the same as the respective column and enum values ​​in the CSV file.':
            'Os valores definidos à esquerda não devem ser alterados. Os valores à direita devem ser iguais aos respectivos valores de coluna e enum no arquivo CSV.',
        'Import Configuration Name': 'Nome da Configuração de Importação',
        'Define a name for the new config...': 'Defina um nome para a nova configuração...',
        'A file with this name already exists. Enter a different name or click the Save button to overwrite it.':
            'Já existe um arquivo com este nome. Insira um nome diferente ou clique no botão Salvar para substituí-lo.',
        Save: 'Salvar',
        'Upload CSV': 'Carregar CSV',
        'Download CSV template': 'Baixar modelo de CSV',
        'The CSV must use a semicolon (;) as a delimiter between values.':
            'O CSV deve usar ponto e vírgula (;) como delimitador entre valores.',
        'Reviews required: ': 'Revisões necessárias: ',
        'You must fix errors identified in the Import Configuration or CSV file, then confirm the data import.':
            'Você deve corrigir os erros identificados na configuração de importação ou no arquivo CSV e, em seguida, confirmar a importação dos dados.',
        'Confirm import data': 'Confirmar dados de importação',
        'Static Data Input File': 'Arquivo de Entrada de Dados Estáticos',
        'Invalid enum value': 'Valor de enum inválido',
        'Invalid attribute': 'Atributo inválido',
        'Move to another': 'Mover para outro(a)',
        'Delete this': 'Remover esse(a)',
        New: 'Novo',
        wells: 'poços',
        interventionKey: 'intervenções',
        sections: 'seções',
        section: 'seção',
        'rig tables': 'mesas rotativas',
        'rig table': 'mesa rotativa',
        runs: 'corridas',
        run: 'corrida',
        'cement plugs': 'plugs cimentados',
        'tubulars type': 'tipos de tubulares',
        'restricted pipe movements': 'movimento dos tubos restritos',
        'restricted pipe movement': 'movimento do tubo restrito',
        'restricted connections': 'conexões restritas',
        'restricted connection': 'conexão restrita',
        'restricted rops': 'rops restritos',
        'restricted rop': 'rop restrito',
        'Well Name': 'Nome do Poço',
        'Well ID': 'ID do Well',
        'Reference System': 'Sistema de Referência Geodésica',
        Tactic: 'Tática de Intervenção',
        startKey: 'Data Inicial',
        End: 'Data Final',
        'Status Reason': 'Motivo',
        'Tubular Interval Per Time': 'Intervalo de tubulares por tempo',
        'Extend Last Tubular': 'Estender o último tubular',
        'Tubular Connection Type': 'Tipo de Conexão Tubular',
        'Permanent Tubular Installation': 'Instalação Tubular Permanente',
        'Restricted Pipe Movement Type': 'Tipo de Movimento Restrito',
        'Restricted Movement Goal': 'Meta do Movimento Restrito',
        'Restriction Type': 'Tipo de Restrição',
        'Restricted Connection Goal': 'Meta de Conexão Restrita',
        'Restricted ROP': 'ROP Restrito',
        'Restricted ROP Goal': 'Meta de ROP Restrita',
        'Error Validation': 'Validação de Erros',
        'Local errors detected': 'Erros locais detectados',
        'Hierarchy errors detected': 'Erros de hierarquia detectados',
        'There are some errors that you need to fix before proceeding with the transfer.':
            'Existem alguns erros que você precisa corrigir antes de prosseguir com a transferência.',
        errorKey: 'erro',
        errorsKey: 'erros',
        found: 'encontrado',
        'must be resolved': 'deve ser resolvido',
        About: 'Sobre',
        'Error transferring the entities': 'Erro ao transferir as entidades',
        'Error validating the entities': 'Erro ao validar as entidades',
        'Error validating the fields': 'Erro ao validar os campos',
        'An error occurred when importing the data': 'Ocorreu um erro ao importar os dados',
        'Unable to save config': 'Não foi possível salvar a configuração',
        'The data was successfully transferred to Static Data Dashboard.':
            'Os dados foram transferidos com sucesso para o Static Data Dashboard.',
        'All validations are ok!': 'Todas as validações estão ok!',
        'The data is ready to be transferred': 'Os dados estão prontos para serem transferidos',
        'It was not possible to validate': 'Não foi possível validar',
        'You need to select some entity': 'Você precisa selecionar alguma entidade',
        'Draft table': 'Tabela temporária',
        draftQuestionMessage: 'Agora que os dados foram transferidos com sucesso, ',
        draftBoldQuestionMessage: 'O que você quer fazer com a tabela de rascunho de dados estáticos?',
        'Discard the draft table': 'Descartar a tabela de rascunho',
        'Keep the draft table': 'Manter a tabela de rascunho',
        'Data has been imported successfully': 'Os dados foram importados com sucesso',
        'Import Configuration has been saved successfully': 'A configuração de importação foi salva com sucesso',
        'Import Configuration has been updated successfully': 'A configuração de importação foi atualizada com sucesso',
        interventions: 'intervenções',
        sections: 'seções',
        'rig tables': 'mesas rotativas',
        runs: 'corridas',
        'cement plugs': 'plugs cimentados',
        'tubular types': 'tipos de tubulares',
        'restricted pipe movements': 'movimentos de tubos restritos',
        'restricted connections': 'conexões restritas',
        'restricted rops': 'rops restritos',
        wells: 'poços',
        'There must be a well.': 'Deve haver um poço',
        'There must be exactly one well.': 'Deve haver exatamente um poço',
        'Unable to get codaf well': 'Não foi possível obter o poço do codaf',
        'Unable to get codaf rig': 'Não foi possível obter a sonda do codaf',
        'Checklist for Intervention': 'Lista de verificação para intervenção',
        'Execution Data': 'Dados de Execução',
        'errors found': 'erros encontrados',
        'error found': 'erro encontrado',
        'Collapse all': 'Recolher todos',
        'Expand all': 'Expandir todos',
        'Permission Required': 'Requer Permissão',
        "You don't have the necessary permissions": 'Você não tem as permissões necessárias',
        'Associated rigs will have RPI calculations grouped into a single table.':
            'Sondas associadas terão cálculos de IDS agrupados em uma única tabela.',
        'RPI calculation is done per Relevant Path by default, but you can change to Non-Relevant Path or both for all individual or associated rigs.':
            'Por padrão, o cálculo do IDS é feito por Caminho Relevante, mas você pode alterar para Caminho Não Relevante ou ambos, para todos as sondas individuais ou associadas.',
        'RPI Path': 'Caminho',
        'RPI Calculation Settings': 'Configurações de Cálculo de IDS',
        'Rigs Association': 'Associação de Sondas',
        'Main Table': 'Mesa Principal',
        'Auxiliary Table': 'Mesa Auxiliar',
        Join: 'Unir',
        Detach: 'Separar',
        'New Rigs Association': 'Nova Associação de Sondas',
        'No options available': 'Nenhuma opção disponível',
        'Expand all': 'Expandir todos',
        'Transfer to KPI Static Data': 'Transferir para KPI Static Data',
        'Confirm transfer': 'Confirmar transferência',
        'TUBULARS INTERVAL': 'INTERVALO DE TUBULARES',
        'Per depth': 'Por profundidade',
        'Per time': 'Por tempo',
        'Cemented Plug': 'Plugue Cimentado',
        'importer.well': 'poço',
        'importer.section': 'seção',
        'importer.rigTable': 'mesa rotativa',
        'importer.run': 'corrida',
        'importer.intervention': 'intervenção',
        'importer.tubular': 'tubular',
        'importer.pipeMovement': 'movimento de tubo',
        'importer.connection': 'conexão',
        'importer.rop': 'rop',
        'importer.cement': 'cimento',
        ...performanceWidgetPt
    }
}
